import { Col, Form, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { MitigationSectionProps } from ".";
import { AMOUNT_UTIL } from "../../../../../../utils/amount.utils";
import AmountInput from "../../../../../atoms/amount-input";
import { InfoCircleIcon } from "../../../../../atoms/icon";
import PercentInput from "../../../../../atoms/percent-input";


const RiskSeverityImpact = (props: MitigationSectionProps) => {

    const { t } = useTranslation();
    const { data } = props;

    return (
        <div className="section-wrapper">
            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbToleranceLevel")}
                        tooltip={{ title: t("ScenarioMitigation.lbToleranceLevel"), icon: <InfoCircleIcon /> }}
                    >
                        <AmountInput value={props.data?.loss_scenario?.tolerance_level} disabled={true} />
                    </Form.Item>
                </Col>

            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbLikelyhood")}
                        tooltip={{ title: t("ScenarioMitigation.lbLikelyhood"), icon: <InfoCircleIcon /> }}
                    >
                        <PercentInput value={props.data?.loss_scenario?.likelihood} disabled={true} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbMaximumExpectedLoss")}
                        tooltip={{ title: t("ScenarioMitigation.lbMaximumExpectedLoss"), icon: <InfoCircleIcon /> }}
                    >
                        <AmountInput value={props.data?.loss_scenario?.maximum_estimated_loss} disabled={true} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbExpectedRecovery")}
                        tooltip={{ title: t("ScenarioMitigation.lbExpectedRecovery"), icon: <InfoCircleIcon /> }}
                    >
                        <AmountInput value={props.data?.loss_scenario?.total_recovery} disabled={true} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24}>
                    <Form.Item
                        label={t("ScenarioMitigation.lbEarningsAtRisk")}
                        tooltip={{ title: t("ScenarioMitigation.lbEarningsAtRisk"), icon: <InfoCircleIcon /> }}
                    >
                        <AmountInput value={props.data?.loss_scenario?.earnings_at_risk} disabled={true} />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={[16, 32]}>
                <Col span={24} className="text-total end-ss">
                    <p>{t("Scenario.lbMaximumEstimatedLoss")}</p><span>{AMOUNT_UTIL.convertNumericToFormattedAmount(data?.loss_scenario?.net_loss)}</span>
                </Col>
            </Row>

        </div>
    )
}

export default RiskSeverityImpact;